module.exports = __webpack_public_path__ + "static/media/sim-card-android.dd9b7f10.webp";